"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DescriptionClickTrigger = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var DESCRIPTION_PANEL_ALIGN_POINTS = [
    { align: "tr tl" },
    { align: "cr cl" },
    { align: "br bl" },
    { align: "tl tr" },
    { align: "cl cr" },
    { align: "bl br" },
    { align: "bl tl" },
    { align: "bc tc" },
    { align: "br tr" },
    { align: "tl bl" },
    { align: "tc bc" },
    { align: "tr br" },
];
exports.DescriptionClickTrigger = function (props) {
    var onOpen = props.onOpen;
    var _a = tslib_1.__read(react_1.useState(false), 2), isOpen = _a[0], setIsOpen = _a[1];
    var switchIsOpen = react_1.useCallback(function () {
        setIsOpen(function (isOpen) {
            if (!isOpen && onOpen) {
                onOpen();
            }
            return !isOpen;
        });
    }, [setIsOpen, onOpen]);
    var iconClassName = classnames_1.default("dash-item-action-description", {
        "dash-item-action-description-active": isOpen,
    }, props.className);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: iconClassName, onClick: switchIsOpen },
            react_1.default.createElement(sdk_ui_kit_1.DescriptionIcon, { className: "dash-item-action-description-trigger" })),
        isOpen ? (react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-light gd-description-panel-bubble", alignPoints: DESCRIPTION_PANEL_ALIGN_POINTS, arrowOffsets: sdk_ui_kit_1.DESCRIPTION_PANEL_ARROW_OFFSETS, arrowStyle: { display: "none" }, onClose: switchIsOpen, closeOnOutsideClick: true, closeOnParentScroll: false, alignTo: "." + props.className },
            react_1.default.createElement(sdk_ui_kit_1.DescriptionPanelContent, tslib_1.__assign({}, props)))) : null));
};
//# sourceMappingURL=DescriptionClickTrigger.js.map